import React from "react";
import OnboardingWizard from "./OnboardingWizard";

interface OnboardingPageProps {
  onComplete: () => void;
  onSignOut: () => void;
}

const OnboardingPage: React.FC<OnboardingPageProps> = ({ onComplete, onSignOut }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-brand-light/30">
      <OnboardingWizard onComplete={onComplete} onSignOut={onSignOut} />
    </div>
  );
};

export default OnboardingPage;
